import { useEffect, useState } from "react";
import {
  cloneTeamContent,
  DEFAULT_TEAM_CONTENT,
  parseTeamContent,
} from "../content/teamContent";
import { listPublicPageContents } from "./cmsApi";

export default function usePublicTeamContent() {
  const [content, setContent] = useState(() => cloneTeamContent(DEFAULT_TEAM_CONTENT));

  useEffect(() => {
    let cancelled = false;

    listPublicPageContents("team")
      .then((sections) => {
        const section = sections.find(
          (item) => item.sectionName === "team" && item.isActive !== false
        );
        const parsed = section ? parseTeamContent(section.content) : null;
        if (!cancelled && parsed) setContent(parsed);
      })
      .catch(() => {
        // Houd de geback-upte teaminhoud zichtbaar als het CMS niet bereikbaar is.
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return content;
}
